'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.controller("CoucheAdditionnelleCreationPopinController", function ($scope, $q, $http, $translate, lovService, $notifications, coucheAdditionnelleService) {
  var isEdit = $scope.edit;
  var originalCoucheAdditionnelle = isEdit || $scope.coucheAdditionnelle != null ? $scope.coucheAdditionnelle : {
    nom: null
  };
  var coucheAdditionnelle = $scope.coucheAdditionnelle = angular.copy(originalCoucheAdditionnelle);
  $scope.originalClassification = angular.copy(originalCoucheAdditionnelle);
  $scope.coucheAdditionnelleFormConfig = {
    url: function url() {
      return '/rest/saisie/couche-additionnelle';
    },
    data: function data() {
      return coucheAdditionnelle;
    },
    fieldPrefix: "coucheAdditionnelle.",
    customValidation: function customValidation() {
      var errors = [];
      if ($scope.coucheAdditionnelle.nom == null || $scope.coucheAdditionnelle.nom.trim().length === 0) {
        errors.push({
          fieldName: 'nom',
          message: 'Le nom est obligatoire.'
        });
      }
      return errors;
    },
    onSuccess: function onSuccess(savedClassification) {
      _.extend(coucheAdditionnelle, savedClassification);
      coucheAdditionnelleService.$reload();
      $notifications.info("Couche additionnelle enregistrée");
      $scope.$close(coucheAdditionnelle);
    },
    onError: function onError(errors) {}
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/coucheAdditionnelle/coucheAdditionnelleCreationPopin.js
// module id = 2769
// module chunks = 13